<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- container -->
    <div class="container">
      <!-- 步骤条 -->
      <el-steps :active="2" align-center>
        <el-step title="选择影片场次"></el-step>
        <el-step title="选择座位"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="影院取票观影"></el-step>
      </el-steps>
      <!-- main -->
      <div class="main">
        <div class="hall">
          <!-- 座位图标说明 -->
          <div class="seat-example">
            <div class="example">
              <img src="@/assets/images/seat/seatSale.png">
              <span>可选座位</span>
            </div>
            <div class="example">
              <img src="@/assets/images/seat/seatSold.png">
              <span>已售座位</span>
            </div>
            <div class="example">
              <img src="@/assets/images/seat/seatSelect.png">
              <span>已选座位</span>
            </div>
            <div class="example">
              <img class="couple" src="@/assets/images/seat/seatSaleLR.png">
              <span>情侣座位</span>
            </div>
          </div>
          <!-- 分区座位图标说明 -->
          <div class="zone-seat-example" v-if="areaNoList.length>1">
            <div class="example" v-for="(item, index) in areaNoList" :key="index">
              <img :src="areaIconList[index]"/>
              <p>{{item}}</p>
            </div>
          </div>
          <!-- 座位区域 -->
          <div class="defaultArea" style="width:100%" :style="{height:seatArea + 'px'}">
            <div class='movableOne' style="width:100%" :style="{height:seatArea + 'px'}">
              <!-- 左侧索引条 -->
              <div class="row-id-container" :style="{height:seatArea + 'px'}">
                <span class="row-id" :style="{height:seatScaleHeight+'px'}" v-for="(item,index) in hallseatList" :key="index">
                  <span v-if="whetAdd == 0">{{item.rowId}}</span>
                  <span v-else>{{item.rowId.substring(0,item.rowId.length-1)}}</span>
                </span>
              </div>
              <!-- 座位区 -->
              <!-- width:seatScaleHeight * maxX + 'px' -->
              <!-- width:90+'%' -->
              <div class='seatArea' :style="{width:seatScaleHeight * maxX + 'px', height:100 + seatScaleHeight*maxY + 'px'}">
                <!--中轴线  -->
                <div :style="{width:seatScaleHeight * maxX + 'px'}"><div class='alignLine'></div></div>
                <!-- 厅 -->
                <div class='hallName'>
                  <span>{{showDetail.hallName}}</span>
                </div>
                <!-- 座位 -->
                <div v-for="(item, index) in seatList" :key="index" class='seatTap'
                  @click='clickSeat(index)' 
                  :style="{left:(item.gCol-1)* seatScaleHeight + 'px',top:100 + (item.gRow-1) * seatScaleHeight + 'px',width: seatScaleHeight + 'px',height: seatScaleHeight + 'px'}">
                  <img :src="item.nowIcon" class='normal' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="side">
          <div class="movie-info">
            <div class="left">
              <img :src="showDetail.photo">
              <!-- <img src="showDetail.film_title"> -->
            </div>
            <div class="right">
              <p>{{showDetail.film_title}}</p>
              <p class="info-item">
                <span></span>
                <span>类型 :</span>
                <span class="value">{{showDetail.category}}</span>
              </p>
              <p class="info-item">
                <span></span>
                <span>时长 :</span>
                <span class="value">{{showDetail.dur}}分钟</span>
              </p>
            </div>
          </div>
          <div class="show-info">
            <div class="info-item">
              <span>影院 :</span>
              <span class="value">{{showDetail.cinemaName}}</span>
            </div>
            <div class="info-item">
              <span>影厅 :</span>
              <span class="value">{{showDetail.hallName}}</span>
            </div>
            <div class="info-item">
              <span>版本 :</span>
              <span class="value">{{showDetail.film_dimensional}}</span>
            </div>
            <div class="info-item">
              <span>场次 :</span>
              <span class="value red">{{showDetail.date}}  {{showDetail.time}}</span>
            </div>
            <!-- <div class="info-item">
              <span>票价 :</span>
              <span class="value">￥38/张</span>
            </div> -->
          </div>
          <div class="ticket-info">
            <!-- 未选择座位时 -->
            <div class="no-ticket" v-if="selectedSeat.length<=0">
              <p class="buy-limit">座位：一次最多选4个座位</p>
              <p class="no-selected">请<span>点击左侧</span>座位图选择座位</p>
            </div>
            <!-- 选择座位时 -->
            <div class="has-ticket" v-else>
              <span class="text">座位：</span>
              <div class="ticket-container">
                <span class="ticket" v-for="(selectedSeatItem, index) in selectedSeat" :key="index" 
                  @click='clickSeat(selectedSeatItem.orgIndex)'>
                  <span v-if="whetAdd == '0'">{{selectedSeatItem.rowId}}排{{selectedSeatItem.gCols}}座</span>
                  <span v-else>{{selectedSeatItem.rowId}}{{selectedSeatItem.gCols}}</span>
                </span>
              </div>
            </div>
            <div class="total-price">
              <span>总价 :</span>
              <span class="prices"><span class="price">{{totalPrice}}</span></span>
            </div>
          </div>
          <div class="confirm-order">
            <!-- 有手机号时 -->
            <!-- <div class="cellphone" v-if="showDetail.mobile">
              <span>手机号 :</span>
              <span class="phone-num">{{showDetail.mobile}}</span>
            </div> -->
            <!-- 无手机号时 -->
            <div class="confirm-wrapper">
              <div class="input-wrapper">
                <input type="text" maxlength="11" placeholder="输入手机号" @input='handleInputChange' v-model="showDetail.mobile">
              </div>
              <!-- <div class="btn-wrapper">
                <p class="btn" @click="toConfirm">确认选座</p>
              </div> -->
            </div>
            <div class="btn-wrapper">
              <p :class="['btn', selectedSeat.length<=0?'disable':'']" @click="confirmHandle">确认选座</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import { MessageBox} from 'element-ui'
  import {qryUnOrderStatus, getShowDetail, getShowSeatList, releaseSeat, getlock} from '@/api/film'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 选中的当前导航
        selected: "",
        sid: this.$route.query.sid,// 排期编号
        // 城市名称
        cityName: '',
        showDetail: {},// 排期信息
        seatList: [], //座位信息
        totalPrice: 0, //座位总金额
        selectedSeat: [], //已选座位信息
        hidden: true, //已选座位区域是否隐藏
        seatArea: '',
        maxSelect: 4, //最大可售座位
        maxY: null,
        maxX: null,
        whetAdd: '', //是否显示“排 座” 0-加  1-不加
        seatScale: null,
        seatScaleHeight: null,
        rpxToPx: null,
        window: false, //身份弹出框状态
        accountUrl: '', //身份列表地址
        identity: true, //是否需要身份信息
        identitys: '', //身份信息
        hallseatList:[],
        // 全部分区号List
        areaNoList: [],
        // 全部分区图标List
        areaIconList: [require("@/assets/images/seat/section1.png"),require("@/assets/images/seat/section2.png"),require("@/assets/images/seat/section3.png"),require("@/assets/images/seat/section4.png"),require("@/assets/images/seat/section5.png")]
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
        // 获取城市名称
        this.cityName = localStorage.getItem('cityName');
        let screenHeight = window.screen.height;
        let screenWidth = window.screen.width;
        let statusBarHeight = 0;
        // this.seatArea = screenHeight - statusBarHeight - (700 * screenWidth / 750);
        this.seatArea = screenHeight;
        // this.rpxToPx = screenWidth / 750;
        this.rpxToPx = 1.2;

        console.log("screenHeight:"+screenHeight)
        console.log("screenWidth:"+screenWidth)
        console.log("seatArea:"+this.seatArea)
        console.log("rpxToPx:"+this.rpxToPx)

        //查询未支付订单信息
        this.qryUnOrderStatus();
        // 获取排期信息
        this.getShowDetail();
        // 获取接口座位
        this.getShowSeatList();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.cityName = localStorage.getItem("cityName");
      },
      // 查询未支付订单信息
      qryUnOrderStatus() {
        let data = {};
        qryUnOrderStatus(data).then(response => {
          let orderid = response.data; //订单编号
          if ("" != orderid && null != orderid) {
            this.$confirm('当前已有订单是否完成').then(action => {
              // 确认的回调--跳转到订单详情
              this.$router.push({path: '/orderDetail', query: {orderId: orderid}})
            }, action => {
              let signdata = {orderId: orderid};
              // 取消的回调--作为释放
              let data2 = {orderId: orderid, signdata: signdata};
              releaseSeat(data2).then(response => {
                console.info(response.code);
              });
            });
          }
        });
      },
      // 获取排期信息
      getShowDetail() {
      	let signdata = {sid: this.sid};
        let data = {sid: this.sid, signdata: signdata};
        getShowDetail(data).then(response => {
          this.showDetail = response.data;
          if (response.code == 0) {
            if (response.data.identity == true) {
              this.window = true;
            }
            if (response.data.agree == 0) {
              this.$confirm('',{
                title:'退改签规定协议',
                message:'当您按照页面提示阅读、确认同意本协议及登录（确认使用）看购电影、看购福利等线上产品服务时，即表示您已充分阅读、理解并接受本协议全部内容，并接受本协议的全部内容。如果不同意本协议的任何条款，或者无法理解本协议相关条款含义的，请不要进行后续操作。【退票及改签】在电影放映前，已购票用户如因自身原因或不可抗力无法前往观影的或拟更改观影安排的，根据相关法律法规及监管部门规定及看购福利合作影院的退改签规则，适用不同的退改签规定，具体退票及改签规则以看购影豆、看购福利、看购电影上相应订单展示信息为准。',
                confirmButtonText:'确认',
                cancelButtonText:'取消'
              }).then(action => {
                if (action == 'confirm') {
                  let data2 = {agreeree: '1'};
                  setFreet(data2).then(ss => {
                    if (ss.code == 0) {
                      this.showDetailData();
                    } else {
                      this.$confirm('',{
                        title: '提示',
                        message: ss.msg,
                        showCancelButton: false
                      }).then(action => {
                        if (action == 'confirm') {
                          // 返回上一级
                          this.$router.go(-1);
                        }
                      });
                    }
                  });
                }
              }).catch(error =>{
                if(error == 'cancel'){
                  // 返回上一级
                  this.$router.go(-1);
                }
              });
            }
            this.accountUrl = response.data.accountUrl;
            this.identity = response.data.identity;
          }
        });
      },
      // 获取接口座位
      getShowSeatList() {
        let signdata = {sid: this.sid};
        let data = {sid: this.sid, signdata: signdata};
        getShowSeatList(data).then(res => {
          if(res.code == 0){
            //座位列表
            let seatList = [];
            const getIndex = ((arr, item) => {
              for (var i in arr) {
                if (arr[i] == item) {
                  return i;
                };
              };
            });
            //最大行
            let maxX = res.data.maxX;
            //最大列
            let maxY = res.data.maxY;
            // 是否添加“排 座”
            this.whetAdd = res.data.whetAdd;
            //是否存在情侣座
            let loversFlag = res.data.loversFlag;
            //分区价格
            let priceSettingList = res.data.price_setting;
            // ==========================获取全部分区号List begin=====================
            let areaNoList = [];
            //分区号下标（areaNoList和areaIconList下标取一致）
            let areaNoIndex = 0;
            if(priceSettingList != null){
              for (var r = 0; r < priceSettingList.length; r++) {
                // 分区名称
                areaNoList.push(priceSettingList[r].section_name + ' ' + priceSettingList[r].section_price + '点');
              }
            }
            // ==========================获取全部分区号List end=====================
            //已售座位数据
            let seatInfoList = res.data.seat;
            //影厅座位信息
            let hallseatList = res.data.hallseat;
            this.hallseatList = hallseatList;
            for (var i = 0; i < hallseatList.length; i++) {
              //一行中的所有数据
              let hallseatInfo = res.data.hallseat[i];
              //一行中的列信息
              let hallseatcolIds = hallseatInfo.colIds;
              //一行中的列信息拆分
              let hallseatcolIdList = hallseatcolIds.split('|');

              var array = []
              //循环一行的中的列
              for (var k = 0; k < hallseatcolIdList.length; k++) {
                array.push(hallseatcolIdList[k]);
                //------------------------------座位图标------------------------------
                let nowIcon = require("@/assets/images/seat/seatSale.png"); //当前图标
                let defautIcon = require("@/assets/images/seat/seatSale.png"); //初始图标
                let selectedIcon = require("@/assets/images/seat/seatSelect.png"); //选中图标
                let soldedIcon = require("@/assets/images/seat/seatSold.png"); //已售图标
                let fixIcon = require("@/assets/images/seat/seatRepair.png"); //被选中图标
                //------------------------------座位类型------------------------------
                //一行中的座位类型(G:过道 N:普通 L:情侣座 R:情侣座)
                let hallseattypeInds = hallseatInfo.typeInds;
                //一行中的座位类型拆分
                let hallseattypeIndList = hallseattypeInds.split('|');
                //座位类型(G:过道 N:普通 L:情侣座 R:情侣座)
                let hallseattypeInd = hallseattypeIndList[k];
                //过滤非过道座位
                if (hallseattypeInd != 'E') { //走廊
                  var type = ''

                  //------------------------------分区价格------------------------------
                  //一行中的分区号
                  let hallseatareaNos = hallseatInfo.areaNos;
                  //一行中的分区号拆分
                  let hallseatareaNoList = hallseatareaNos.split('|');
                  //分区号    
                  let areaNos = hallseatareaNoList[k];
                  //分区价格-默认第一个价格
                  let sectionPrice = priceSettingList[0].section_price;
                  for (var z = 0; z < priceSettingList.length; z++) {
                    //分区数组(包含ID和价格)
                    let priceSettingInfo = priceSettingList[z];
                    //分区号
                    let sectionId = priceSettingInfo.section_id;
                    //分区号相同情况下赋值分区价格
                    if (areaNos == sectionId) {
                      //分区价格使用用户支付价格
                      sectionPrice = priceSettingInfo.section_price;
                      //下标
                      areaNoIndex = z;
                    }
                  }
                  if (hallseattypeInd == 'N') { //可售
                    type = '0'
                    if(areaNoList.length > 1){  //分区时
                      nowIcon = this.areaIconList[areaNoIndex]; //当前图标
                      defautIcon = this.areaIconList[areaNoIndex]; //初始图标
                    }else{  //没有分区时
                      nowIcon = require("@/assets/images/seat/seatSale.png"); //当前图标
                      defautIcon = require("@/assets/images/seat/seatSale.png"); //初始图标
                    }

                  } else if (hallseattypeInd == 'L') { //情侣座
                    type = '1'
                    nowIcon = require("@/assets/images/seat/seatSaleL.png"); //当前图标
                    defautIcon = require("@/assets/images/seat/seatSaleL.png"); //初始图标
                  } else if (hallseattypeInd == 'R') { //情侣座
                    type = '2'
                    nowIcon = require("@/assets/images/seat/seatSaleR.png"); //当前图标
                    defautIcon = require("@/assets/images/seat/seatSaleR.png"); //初始图标
                  } else if (hallseattypeInd == 'F') { //禁止售卖
                    type = '0-2'
                    nowIcon = require("@/assets/images/seat/seatForbid.png"); //当前图标
                    defautIcon = require("@/assets/images/seat/seatForbid.png"); //初始图标
                    soldedIcon = require("@/assets/images/seat/seatForbid.png"); //已售图标
                  } else {
                    type = '0-2'
                    nowIcon = require("@/assets/images/seat/seatSold.png"); //当前图标
                    defautIcon = require("@/assets/images/seat/seatSold.png"); //初始图标
                    soldedIcon = require("@/assets/images/seat/seatSold.png"); //已售图标  
                  }
                  //------------------------------已售座位------------------------------
                  //一行中的座位号
                  let hallseatseatIds = hallseatInfo.seatIds;
                  //一行中的座位号拆分
                  let hallseatseatIdList = hallseatseatIds.split('|');
                  //座位号
                  let hallseatseatId = hallseatseatIdList[k];
                  if (null !== seatInfoList && hallseattypeInd != 'F') {
                    //循环已售座位信息
                    for (var d = 0; d < seatInfoList.length; d++) {
                      //已售座位号
                      let soldSeatId = seatInfoList[d];
                      //座位号相同情况下设置不可售
                      if (hallseatseatId == soldSeatId) {
                        if (hallseattypeInd == "L") {
                          type = "1-2"
                          nowIcon = require("@/assets/images/seat/seatSoldL.png"); //当前图标
                          defautIcon = require("@/assets/images/seat/seatSoldL.png"); //初始图标
                          soldedIcon = require("@/assets/images/seat/seatSoldL.png"); //已售图标
                        } else if (hallseattypeInd == "R") {
                          type = "2-2"
                          nowIcon = require("@/assets/images/seat/seatSoldR.png"); //当前图标
                          defautIcon = require("@/assets/images/seat/seatSoldR.png"); //初始图标
                          soldedIcon = require("@/assets/images/seat/seatSoldR.png"); //已售图标
                        } else {
                          type = "0-2"
                          nowIcon = require("@/assets/images/seat/seatSold.png"); //当前图标
                          defautIcon = require("@/assets/images/seat/seatSold.png"); //初始图标
                          soldedIcon = require("@/assets/images/seat/seatSold.png"); //已售图标
                        }
                      }
                    }
                  }
                  //判断座位是否可以点击
                  let canClick = true;
                  // 如果座位是已经售出 和 维修座位 加入属性canClick 判断座位是否可以点击
                  if (defautIcon === soldedIcon || defautIcon === fixIcon) {
                    canClick = false
                  }
                  
                  this.seatList.push({
                    "id": hallseatInfo.seatIds.split('|')[k],
                    "row": i + 1,
                    "col": k + 1,
                    "gRow": i + 1,
                    "gCol": Number(getIndex(array, hallseatcolIdList[k])) + 1,
                    "gCols": hallseatcolIdList[k],
                    "type": type,
                    "flag": "0",
                    'rowId': hallseatInfo.rowId,
                    'areaNos': areaNos,
                    "price": sectionPrice,
                    "typeInds": hallseattypeInd,
                    "nowIcon": nowIcon,
                    "defautIcon": defautIcon,
                    "selectedIcon": selectedIcon,
                    "soldedIcon": soldedIcon,
                    "fixIcon": fixIcon,
                    "canClick": canClick,
                    "otherLoveSeatIndex": null,
                    "otherLoveSeatId": null
                  })
                  this.areaNoList = areaNoList;
                }
              }
            }
            var json = {
              "errorCode": 0,
              "errorMsg": "",
              "seatList": this.seatList
            }
            if (loversFlag) {
              var result = json;
              this.seatList = this.prosessSeatList(result);
            }
            setTimeout(function () {
              // wx.hideLoading()
            }, 1000)
            //计算X和Y坐标最大值
            this.prosessMaxSeat(maxX, maxY);
          }
        });
      },
      prosessSeatList: function (response) {
        let resSeatList = response.seatList
        resSeatList.forEach(element => {
          // 获取座位的类型的首字母
          let firstNumber = element.type.substr(0, 1)
          // 在原来的对象中加入两个属性  otherLoveSeatIndex 对应情侣座位的原数组下标 otherLoveSeatId  对应情侣座位的Id
          element.otherLoveSeatIndex = null
          element.otherLoveSeatId = null
          // 座位的类型的首字母为 '1' 是情侣首座 处理情侣首座位
          if (firstNumber === '1') {
            for (const index in resSeatList) {
              if (resSeatList[index].gRow === element.gRow && resSeatList[index].gCol === element.gCol + 1) {
                element.otherLoveSeatIndex = index
                element.otherLoveSeatId = resSeatList[index].id
              }
            }
          }
          // 座位的类型的首字母为 '2' 是情侣次座 处理情侣次座位
          if (firstNumber === '2') {
            for (const index in resSeatList) {
              if (resSeatList[index].gRow === element.gRow && resSeatList[index].gCol === element.gCol - 1) {
                element.otherLoveSeatIndex = index
                element.otherLoveSeatId = resSeatList[index].id
              }
            }
          }
        })
        return resSeatList
      },
      //计算最大座位数,生成影厅图大小
      prosessMaxSeat: function (maxX, maxY) {
        // let seatRealWidth = parseInt(maxX) * 70 * this.rpxToPx
        // let seatRealheight = parseInt(maxY) * 70 * this.rpxToPx
        // let seatScale = 1;
        // let seatScaleX = 1;
        // let seatScaleY = 1;
        // let seatAreaWidth = 630 * this.rpxToPx
        // let seatAreaHeight = this.seatArea - 200 * this.rpxToPx
        // if (seatRealWidth > seatAreaWidth) {
        //   seatScaleX = seatAreaWidth / seatRealWidth
        // }
        // if (seatRealheight > seatAreaHeight) {
        //   seatScaleY = seatAreaHeight / seatRealheight
        // }
        // if (seatScaleX < 1 || seatScaleY < 1) {
        //   seatScale = seatScaleX < seatScaleY ? seatScaleX : seatScaleY
        // }
        this.maxY = parseInt(maxY);
        this.maxX = parseInt(maxX);
        // this.seatScale = seatScale;
        // this.seatScaleHeight = seatScale * 70 * this.rpxToPx;
        this.seatScale = 900;
        this.seatScaleHeight = 40;
      },
      // 点击每个座位触发的函数
      clickSeat(index){
        if (this.seatList[index].canClick) {
          if (this.seatList[index].nowIcon === this.seatList[index].selectedIcon) {
            this.processSelected(index)
          } else {
            this.processUnSelected(index)
          }
        }
        if (this.selectedSeat.length == 0) {
          this.hidden = true;
        }

        let _selectedSeatList = this.selectedSeat
        let totalPrice = 0
        for (const key in _selectedSeatList) {
          let price = parseInt(_selectedSeatList[key].price);
          totalPrice += price;
        }
        this.totalPrice = totalPrice;
      },
      // 处理已选的座位
      processSelected: function (index) {
        let _selectedSeatList = this.selectedSeat
        let seatList = this.seatList
        let otherLoveSeatIndex = seatList[index].otherLoveSeatIndex
        if (otherLoveSeatIndex !== null) {
          // 如果是情侣座位
          // 改变这些座位的图标为初始图标
          seatList[index].nowIcon = seatList[index].defautIcon
          seatList[otherLoveSeatIndex].nowIcon = seatList[otherLoveSeatIndex].defautIcon
          for (const key in _selectedSeatList) {
            // 移除id一样的座位
            if (_selectedSeatList[key].id === seatList[index].id) {
              _selectedSeatList.splice(key, 1)
            }
          }
          // 移除对应情侣座位
          for (const key in _selectedSeatList) {
            if (_selectedSeatList[key].id === seatList[otherLoveSeatIndex].id) {
              _selectedSeatList.splice(key, 1)
            }
          }
        } else {
          // 改变这些座位的图标为初始图标 并 移除id一样的座位
          seatList[index].nowIcon = seatList[index].defautIcon
          for (const key in _selectedSeatList) {
            if (_selectedSeatList[key].id === seatList[index].id) {
              _selectedSeatList.splice(key, 1)
            }
          }
        }
        this.selectedSeat = _selectedSeatList;
        this.seatList = seatList;
      },
      // 处理未选择的座位
      processUnSelected: function (index) {
        let _selectedSeatList = this.selectedSeat
        let seatList = this.seatList
        let otherLoveSeatIndex = seatList[index].otherLoveSeatIndex
        if (otherLoveSeatIndex !== null) {
          // 如果选中的是情侣座位 判断选择个数不大于 maxSelect
          if (_selectedSeatList.length >= this.maxSelect - 1) {
            MessageBox({
              message: '最多只能选择' + this.maxSelect + '个座位哦~',
              duration: 2000
            })
            return
          }
          // 改变这些座位的图标为已选择图标
          seatList[index].nowIcon = seatList[index].selectedIcon
          seatList[otherLoveSeatIndex].nowIcon = seatList[otherLoveSeatIndex].selectedIcon
          // 记录 orgIndex属性 是原seatList数组中的下标值
          seatList[index].orgIndex = index
          seatList[otherLoveSeatIndex].orgIndex = otherLoveSeatIndex
          // 把选择的座位放入到已选座位数组中
          let temp = {
            ...seatList[index]
          }
          let tempLove = {
            ...seatList[otherLoveSeatIndex]
          }
          _selectedSeatList.push(temp)
          _selectedSeatList.push(tempLove)
        } else {
          // 如果选中的是非情侣座位 判断选择个数不大于 maxSelect
          if (_selectedSeatList.length >= this.maxSelect) {
             MessageBox({
              message: '最多只能选择' + this.maxSelect + '个座位哦~',
              duration: 2000
            })
            return
          }
          // 改变这些座位的图标为已选择图标
          seatList[index].nowIcon = seatList[index].selectedIcon
          // 记录 orgIndex属性 是原seatList数组中的下标值
          seatList[index].orgIndex = index
          // 把选择的座位放入到已选座位数组中
          let temp = {
            ...seatList[index]
          }
          _selectedSeatList.push(temp)
        }
        this.selectedSeat = _selectedSeatList;
        this.seatList = seatList;
        this.hidden = false;
      },
      // 确认选座 
      confirmHandle(){
        let that = this;
        if (that.selectedSeat.length === 0) {
          MessageBox({
            message: '请至少选择一个座位~',
            duration: 2000
          });
          return
        }
        // 开始计算是否留下空位 ------------ 开始
        // let result = true;
        let result = that.selectedSeat.every(function (element, index, array) {
          return that.checkSeat(element, that.selectedSeat)
        })
        // 开始计算是否留下空位 ------------ 结束
        if (!result) {
          // 如果 result 为false
          MessageBox({
            message: '请不要留下空位~',
            duration: 2000
          });
        } else {
          if (this.totalPrice === 0) {
            MessageBox({
              message: '锁座失败了~,金额为0',
              duration: 2000
            });
            return
          }
          // 允许锁座
          // Indicator.open('加载中');
          this.createOrder()
        }
      },
      // 获取实时手机号值
      handleInputChange(e){
        // 刷新数据
        if(e.currentTarget.value.length == 11){
          this.showDetail.mobile = e.currentTarget.value;
        }
      },
      //点击确认选择开始生成订单
      createOrder: function () {
        if (this.showDetail.mobile == null || this.showDetail.mobile == '') {
           MessageBox({
            message: '请输入手机号~',
            duration: 2000
          })
          return
        }
        let selectSeatInfo = this.selectedSeat;
        let selectSeatNumber = 0;
        if (selectSeatInfo) {
          selectSeatNumber = selectSeatInfo.length;
        }
        //锁座
        this.lockSeat();
        // 验证身份信息 暂时不用
        // if (this.identity == true) {
        //   //组装身份信息h5页面
        //   let accountUrl = encodeURIComponent(this.accountUrl + "&num=" + selectSeatNumber);
        //   this.$router.push({path: '/pageIdentity', query: {accountUrl: accountUrl}})
        //   //这里编写开始创建订单逻辑
        // } else {
        //   //锁座
        //   this.lockSeat();
        // }
        return
      },
      //锁座
      lockSeat() {
        let selectSeatInfo = this.selectedSeat;
        var seatInfoList = [];
        if (selectSeatInfo) {
          for (var i = 0; i < selectSeatInfo.length; i++) {
            seatInfoList.push({
              "sectionId": selectSeatInfo[i].areaNos,
              "seatId": selectSeatInfo[i].id,
              "rowId": selectSeatInfo[i].rowId,
              "columnId": selectSeatInfo[i].gCols
            });
          }
        }
        var seatInfo = JSON.stringify(seatInfoList);
        let signdata = {sid: this.sid, identitys: this.identitys, agree: '1', seatInfo: seatInfo}
        let data = {whetAdd: this.whetAdd, source: 'pc',mobile: this.showDetail.mobile, sid: this.sid, identitys: this.identitys, agree: '1', seatInfo: seatInfo, signdata: signdata}
        getlock(data).then(res => {
          //隐藏加载框
          // Indicator.close();
          if (res.code == 0) {
            this.$router.push({path: '/confirmOrder', query: {orderId: res.data}});
          } else {
            //数组重新赋值
            this.$message({
              title: '提示',
              message: res.msg,
              showCancel: false
            });
          }
        });
      },
      //电影放映场所恢复开放疫情防控指南-确定
      verification() {
        this.window = false;
      },
      // 检查每个座位是否会留下空位
      checkSeat: function (element, selectedSeat) {
        // 标准为 1.左右侧都必须保留 两格座位 + 最大顺延座位(也就是已选座位减去自身)
        // 2.靠墙和靠已售的座位一律直接通过
        const checkNum = 2 + selectedSeat.length - 1
        const gRowBasic = element.gRow
        const gColBasic = element.gCol
        let otherLoveSeatIndex = element.otherLoveSeatIndex
        if (otherLoveSeatIndex != null) {
          // 如果是情侣座 不检测
          return true
        }
        // 检查座位左侧
        let left = this.checkSeatDirection(gRowBasic, gColBasic, checkNum, '-', selectedSeat)
        // 如果左侧已经检查出是靠着过道直接 返回true
        if (left === 'special') {
          return true
        }
        // 检查座位右侧
        let right = this.checkSeatDirection(gRowBasic, gColBasic, checkNum, '+', selectedSeat)
        if (right === 'special') {
          // 无论左侧是否是什么状态 检查出右侧靠着过道直接 返回true
          return true
        } else if (right === 'normal' && left === 'normal') {
          // 如果左右两侧都有富裕的座位 返回true
          return true
        } else if (right === 'fail' || left === 'fail') {
          // 如果左右两侧都是不通过检测 返回false
          return false
        }
        return true
      },
      // 检查左右侧座位满足规则状态
      checkSeatDirection: function (gRowBasic, gColBasic, checkNum, direction, selectedSeat) {
        // 空位个数
        let emptySeat = 0
        let x = 1 // 检查位置 只允许在x的位置出现过道,已售,维修
        for (let i = 1; i <= checkNum; i++) {
          let iter // 根据 gRow gCol direction 找出检查座位左边按顺序排列的checkNum
          if (direction === '-') {
            iter = this.seatList.find(function (el) {
              return el.gRow === gRowBasic && el.gCol === gColBasic - i
            })
          } else if (direction === '+') {
            iter = this.seatList.find(function (el) {
              return el.gRow === gRowBasic && el.gCol === gColBasic + i
            })
          }
          if (x === i) {
            if (iter === undefined) {
              // 过道
              return 'special'
            }
            if (iter.nowIcon === iter.soldedIcon || iter.nowIcon === iter.fixIcon) {
              // 已售或者维修
              return 'special'
            }
            let checkSelect = false
            for (const index in selectedSeat) {
              if (selectedSeat[index].id === iter.id) {
                // 已选 顺延一位
                x++
                checkSelect = true
                break;
              }
            }
            if (checkSelect) {
              continue
            }
          } else {
            if (iter === undefined) {
              // 过道
              return 'fail'
            }
            if (iter.nowIcon === iter.soldedIcon ||
              iter.nowIcon === iter.fixIcon) {
              // 已售或者维修
              return 'fail'
            }
            let checkSelect = false
            for (const index in selectedSeat) {
              if (selectedSeat[index].id === iter.id) {
                return 'fail'
              }
            }
          }
          emptySeat++
          if (emptySeat >= 2) {
            return 'normal'
          }
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-top: 120px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    width: 75%;
    /*width: 1200px;*/
  }
  .main {
    margin-top: 40px;
    width: 100%;
    border: 1px solid #e5e5e5;
    font-size: 0;
  }
  .hall {
    width: 70%;
    display: inline-block;
    vertical-align: top;
  }
  .hall .seat-example {
    width: 80%;
    margin: 30px auto;
    white-space: nowrap;
  }
  .hall .seat-example .example {
    display: inline-block;
    font-size: 16px;
    color: #666;
    height: 26px;
    line-height: 26px;
    width: 25%;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    background-repeat: no-repeat;
  }
  .hall .seat-example .example img{
    display: inline-block;
    margin-right: 10px;
    width: 25%;
    height: 100%;
    vertical-align: middle;
  }
  .hall .seat-example .example img.couple{
    width: 50%;
  }
  .row-id-container {
    position: absolute;
    float: left;
    margin-top: 100px;
    width: 20px;
    white-space: normal;
    background: #fff;
  }
  .row-id {
    font-size: 16px;
    color: #999;
    display: inline-block;
    width: 20px;
    text-align: center;
  }
  /*web*/
  /*影厅图上方显示影厅名字区域*/
    .hallName {
      width: 350px;
      height: 0;
      border-top: 40px solid #ccc;
      border-right: 20px solid transparent;
      border-left: 20px solid transparent;
      line-height: 30px;
      color: white;
      position: absolute;
      top: 0;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }
    /*影厅图上方显示影厅名字区域字体样式*/
    .hallName span {
      font-size: 20px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -32px;
    }
    /*所有座位的区域*/
    .seatArea {
      position: relative;
      left: 20px;
      margin-left: 50px;
      font-size: 10px;
      overflow-x: auto;
      overflow-y: hidden;
      margin: 0 auto;
    }
    /*中轴线*/
    .alignLine {
      position: absolute;
      left: 50%;
      top: 100px;
      height: 100%;
      border-left: 1px dashed #aaa;
      transform: translateX(-100%);
    }
    /*选座区域普通座位的图片样式*/
    .normal {
      position: relative;
      /*width: 100%;
      height: 100%;*/
      width: 30px;
      height: 26px;
    }
    /*选座区域情侣座位的图片样式*/
    .LoveSeat {
      position: relative;
      width: 70px;
      height: 70px;
    }
    /*所有座位的图片样式下方透明可点击区域*/
    .seatTap {
      position: absolute;
    }
    /* 左侧排条 */
    .leftLine{
      position: absolute;
      text-align: center;
    }
    .leftLine .leftCol{
      font-size: 16px;
      background: #666666;
    }
    /*情侣座位的图片样式下方透明可点击区域*/
    .LoveSeatTap {
      position: absolute;
      top: 0;
      width: 70px;
      height: 70px;
    }
  /*座位图限制区域*/
    .defaultArea {
      background: #fff;
      overflow: auto;
    }
    /*座位图可移动区域(座位图)*/
    .movableOne {
      position: relative;
      box-sizing: border-box;
      padding: 10px 10px;
      color: #fff;
    }
    .ui-share-hover{
      opacity: 0.9;
      transform: scale(0.9,0.9);
    }
  /*side*/
  .side {
    display: inline-block;
    padding: 20px;
    width: 30%;
    box-sizing: border-box;
    background-color: #f9f9f9;
    text-align: left;
  }
  .movie-info{
    height: 158px;
  }
  .movie-info .left{
    width: 115px;
    height: 158px;
    border: 2px solid #fff;
    -webkit-box-shadow: 0 2px 7px 0 hsla(0,0%,53%,.5);
    box-shadow: 0 2px 7px 0 hsla(0,0%,53%,.5);
    float: left;
  }
  .side .movie-info .left img {
    display: block;
    width: 115px;
    height: 158px;
  }
  .side .movie-info .right {
    margin-left: 140px;
    font-size: 20px;
    font-weight: 700;
    color: #333;
    text-align: left;
  }
  .side .movie-info .right .info-item {
    margin-top: 14px;
    margin-bottom: 4px;
    font-size: 12px;
    color: #999;
  }
  .side .movie-info .info-item .value {
    margin-left: 2px;
    color: #151515;
  }
  .side .show-info{
    margin-top: 50px;
  }
  .side .show-info .info-item {
    margin-bottom: 9px;
  }
  .side .show-info .info-item span {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    vertical-align: bottom;
  }
  .side .show-info .info-item span:nth-child(1){
    color: #999;
  }
  .side .show-info .info-item .value {
    padding-left: 5px;
    width: 85%;
  }
  .side .show-info .info-item .value.red {
    color: #f03d37;
  }
  .side .ticket-info {
    padding: 20px 0 10px;
    border-top: 1px dashed #e5e5e5;
    border-bottom: 1px dashed #e5e5e5;
  }
  .side .ticket-info .text {
    font-size: 14px;
    color: #999;
    float: left;
  }
  .side .ticket-info .ticket-container {
    margin-left: 42px;
    margin-bottom: 20px;
    position: relative;
    top: -5px;
  }
  .side .ticket-info .ticket {
    cursor: default;
    position: relative;
    font-size: 12px;
    color: #f03d37;
    display: inline-block;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    margin: 0 12px 10px 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAeCAYAAABwmH1PAAAAAXNSR0IArs4c6QAAAXlJREFUWAlj/Oho7cXAzLTg/89fogzDGDCys71m+PsvgeGji+2r38eP/h/u4Pexo/9BfmUCxSyLhdUwjluI11gsrRhAfmUa9j5F8+Coh9ECZNhxR2N42EUpmodGZgx/TYz9+nvzhn9ogTEsuUysDGxS/548jP4+qe/0l6zUL//fvh2WHoV5ihHGALa0GD872rQxamrm8EybzQMTH070RzsLBngeZmRk/M+7/0jVv9s3rw7n5A33MCgmQZ4GRnn7r3Vrvw+nmEX2C4qHQRLMPxlO/X38kA1Z0XBiY3h4OHkOm18wPPyXncGMWVb+FzbFw0EMxcOgkvo/A0MlW1Aw53DwHDY/wD0Mq5aYVNW1WX0D4OLYNA1lMZavtraSoGT8ydWukklTU5u7uWNY1sGwSGL5zfDrGYuM6ldQMh7OMQv3MIjBPX8xN0xguNPDNq/iirhRD+MKmeEiPhrDwyUmcflj5MUwaM7lz/FjuAJk2IiD/AjyK+NIm0wDAACxUs8MaULTAAAAAElFTkSuQmCC) no-repeat;
  }
  .side .ticket-info .total-price {
    font-size: 14px;
    color: #333;
  }
  .side .ticket-info .total-price .prices {
    color: #f03d37;
    font-size: 14px;
  }
  .side .ticket-info .total-price .prices .price{
    font-size: 24px;
  }
  .side .confirm-order {
    padding: 20px 0;
    text-align: center;
  }
  .side .confirm-order .cellphone {
    color: #999;
    font-size: 14px;
  }
  .side .confirm-order .cellphone .phone-num {
    color: #151515;
  }
  .side .confirm-wrapper {
    display: inline-block;
    width: 100%;
    padding: 0;
  }
  .side .confirm-wrapper .input-wrapper{
    position: relative;
    display: inline-block;
    padding: 0;
    margin: 0;
    border: none;
  }
  .side .confirm-wrapper .input-wrapper input {
    display: block;
    width: 100%;
    height: 40px;
    border: 1px solid #e5e5e5;
    border-radius: 50px;
    margin-bottom: 6px;
    padding: 0 20px;
    color: #333;
    background: #fff;
    box-sizing: border-box;
    font-size: 14px;
  }
  .side .btn-wrapper{
    margin-top: 45px;
  }
  .side .btn-wrapper .btn {
    margin: 0 auto;
    width: 100%;
    line-height: 42px;
    border-radius: 21px;
    font-size: 16px;
    color: #fff;
    -webkit-box-shadow: 0 2px 10px -2px #f03d37;
    box-shadow: 0 2px 10px -2px #f03d37;
    background-color: #f03d37;
    cursor: pointer;
  }
  .side .btn-wrapper .btn.disable{
    background-color: #dedede;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .ticket-info .buy-limit {
    font-size: 14px;
    color: #999;
    margin: 0;
  }
  .side .ticket-info .no-selected {
    font-size: 14px;
    color: #333;
    text-align: center;
    margin: 28px 0 39px;
  }
  .side .ticket-info .no-selected span {
    color: #f03d37;
  }
  /*分区*/
  .zone-seat-example {
    padding-bottom: 10px;
    width: 100%;
    text-align: center;
    white-space: nowrap;
  }
  .zone-seat-example .example {
    display: inline-block;
    color: #999;
    height: 24px;
    line-height: 24px;
    padding-right: 20px;
    background-repeat: no-repeat;
  }
  .zone-seat-example .example p{
    display: inline-block;
    font-size: 18px;
  }
  .zone-seat-example .example img{
    display: inline-block;
    margin-right: 10px;
    width: 24px;
    height: 24px;
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// src/views/seat.vue